import { useId } from 'react';
import { NumberField } from '../../components/FilterRules/FilterControls';
import { CountNote, SeedMixField, SeedMixRow } from '../../components/form.styles';
import {
  BRAND_SHARE_ERROR,
  describeSeedSplit,
  isValidBrandShare,
  seedSplit
} from '../../lib/brandShare';

type BrandShareFieldProps = {
  /** The share in the field; null while it is blank. */
  value: number | null;
  /** The draft's size cap, which sets the seed size the split reads from. */
  uniqueIndividualLimit: number | null;
  onChange: (value: number | null) => void;
};

/**
 * The brand share input, with the seed split it gives.
 *
 * An invalid share shows `BRAND_SHARE_ERROR` in place of the split.
 */
const BrandShareField = ({ value, uniqueIndividualLimit, onChange }: BrandShareFieldProps) => {
  const inputId = useId();
  const valid = isValidBrandShare(value);
  return (
    <SeedMixRow>
      <SeedMixField>
        <label htmlFor={inputId}>Brand share</label>
        <NumberField
          id={inputId}
          label="Brand share"
          value={value}
          suffix="%"
          invalid={!valid}
          onChange={onChange}
        />
      </SeedMixField>
      {valid ? (
        <CountNote>{describeSeedSplit(seedSplit(uniqueIndividualLimit, value))}</CountNote>
      ) : (
        <CountNote tone="error" role="alert">
          {BRAND_SHARE_ERROR}
        </CountNote>
      )}
    </SeedMixRow>
  );
};

export default BrandShareField;
